export default "__VITE_ASSET__BhwX3zXg__"